import { BellRing } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const Navbar = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const setNavHeader = (pathname: string) => {
    switch(pathname) {
      case "/supplement": return "Dashboard";
      case "/supplement/orders": return "Order Management";
      case "/supplement/inventory": return "Inventory Management";
      case "/supplement/gallery": return "Image Gallery";
      case "/supplement/notifications": return "Notifications"
      default : return "Dashboard"
    }
  };

  return (
    <nav>
      <div className="sticky top-0 z-10 bg-slate-50/20 backdrop-blur-md border-b border-slate-200 px-4 flex items-center justify-between h-16">
        <div className="flex items-center gap-4">
          <div className="flex flex-col">
            <h2 className="text-2xl font-bold text-slate-800 capitalize">
              {setNavHeader(pathname)}
            </h2>
          </div>
        </div>
        <div className="flex gap-4">
          <button
            onClick={() => navigate("/supplement/notifications")}
            className="relative px-3 py-2 bg-white border border-amber-300 rounded-xl hover:bg-slate-50 transition-colors shadow-sm"
          >
            <BellRing size={20} className="text-amber-500" />
            {/* {notifications.some((n) => !n.read) && (
                <span className="absolute top-0 right-0 w-3 h-3 bg-rose-500 rounded-full border-2 border-white"></span>
              )} */}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
